import {client} from "../store";
import {gql} from "@apollo/client";

export const INVOICE_LOAD_START = 'INVOICE/INVOICE_LOAD_START';
export const INVOICE_LOAD_FAILED = 'INVOICE/INVOICE_LOAD_FAILED';
export const INVOICE_LOAD_SUCCESS = 'INVOICE/INVOICE_LOAD_SUCCESS';

export function invoiceLoading() {
  return {
    type: INVOICE_LOAD_START
  }
}

export function invoiceLoaded(data) {
  return {
    type: INVOICE_LOAD_SUCCESS,
    payload: data
  }
}

export function invoiceLoadFailed() {
  return {
    type: INVOICE_LOAD_FAILED,
  }
}

export function fetchInvoices(params) {
  if(!params) return async (dispatch) => {
    dispatch(invoiceLoading())

    try {
      const {data} = await client.query({
        query: gql`
            query Claims {
                fosaClaimInvoice {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            dateCreated
                            dateUpdated
                            invoiceNumber
                            subTotal
                            tax
                            totalAmount
                            dateIssued
                            status
                            note
                            submittedBy {
                                id
                                username
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      })
      if (data) {
        dispatch(invoiceLoaded(data));
      }
    } catch (e) {
      console.error(e)
      dispatch(invoiceLoadFailed())
    }
  }


  return async (dispatch) => {
    dispatch(invoiceLoading())

    try {
      const {data} = await client.query({
        query: gql`
            query Claims {
                fosaClaimInvoice(${params.join(" ,")}) {
                    totalCount
                    edgeCount
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        startCursor
                        endCursor
                    }
                    edges {
                        node {
                            id
                            dateCreated
                            dateUpdated
                            invoiceNumber
                            subTotal
                            tax
                            totalAmount
                            dateIssued
                            status
                            note
                            submittedBy {
                                id
                                username
                            }
                        }
                    }
                }
            }
        `,
        fetchPolicy: "network-only",
      })
      if (data) {
        dispatch(invoiceLoaded(data));
      }
    } catch (e) {
      console.error(e)
      dispatch(invoiceLoadFailed())
    }
  }
}

export async function fetchInvoiceById(invoiceId) {
  return await client.query({
    query: gql`
        query ClaimInvoice {
            claimInvoice(id: "${invoiceId}") {
                edges {
                    node {
                        id
                        isDeleted
                        dateCreated
                        jsonExt
                        invoiceNumber
                        subTotal
                        tax
                        totalModerator
                        totalAmount
                        status
                        note
                        dateCreated
                        note
                        userUpdated {
                            username
                        }
                        claimInvoice {
                            totalCount
                            edgeCount
                            edges {
                                node {
                                    id
                                    uuid
                                    code
                                    status
                                    isFullRejected
                                    claimed
                                    totalModerator
                                    dateClaimed
                                    insuree {
                                        camuNumber
                                        otherNames
                                        lastName
                                    }
                                    healthFacility {
                                        id
                                        uuid
                                        name
                                        phone
                                        email
                                        code
                                        jsonExt
                                        fosaCode,
                                        category {
                                            id,
                                            jsonExt,
                                            code,
                                            label,
                                            haveMedicalItem,
                                            havePathology,
                                            serviceCategory {
                                                edges {
                                                    node {
                                                        id name
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    items {
                                        id
                                        item {
                                            id
                                            code
                                            name
                                        }
                                        jsonExt
                                        status
                                        qtyProvided
                                        qtyApproved
                                        priceAsked
                                        priceAdjusted
                                        priceApproved
                                        priceValuated
                                    }
                                    services {
                                        id
                                        service {
                                            serviceCategory {id name }
                                            id
                                            code
                                            name
                                        }
                                        jsonExt
                                        status
                                        qtyProvided
                                        qtyApproved
                                        priceAsked
                                        priceAdjusted
                                        priceApproved
                                        priceValuated
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `,
    fetchPolicy: "network-only",
  })
}

export async function submitInvoice(invoiceId, claims) {
  const mutation = `mutation SubmitInvoice {
      submitInvoice(
        claims: ${JSON.stringify(claims)}, invoiceId: "${invoiceId}"
      ) {
        success
        message
      }
    }
    `;

  const {data} = await client.mutate({
    mutation: gql`
        ${mutation}
    `,
  });


  return data;
}